import get from 'lodash.get';

import { emptyArray, emptyObject } from 'ui-components/default-props/empty';

import * as Actions from './bulk.actions';

const getBatchGroupKeyFromBatches = (action) => {
  const batches = get(action, 'batches', emptyArray);
  const batchGroupKey = batches.join && batches.join('-');

  return batchGroupKey;
};

const initialState = emptyObject;

const reduceBatchGroup = (state = initialState, action) => {
  const { included, excluded, errored, andPrint, batches, metadata } = action;

  const batchGroupKey = getBatchGroupKeyFromBatches(action);
  switch (action.type) {
    case Actions.BULK_PURCHASE_LABEL_SUCCESS:
      return {
        ...state,
        [batchGroupKey]: {
          included,
          excluded,
          errored,
          originalBatches: batches,
          andPrint,
          remainingBatches: batches,
          metadata,
        },
      };
    case Actions.BULK_CLEAR_CREATE_LABEL:
      return {
        ...state,
        [action.batchGroupKey]: undefined,
      };
    case Actions.BULK_PROCESSING_CREATE_LABEL_MARK_BATCH_PROCESSED:
      return {
        [action.batchGroupKey]: {
          ...get(state, action.batchGroupKey, emptyObject),
          remainingBatches: get(action, 'remainingBatches', emptyArray),
        },
      };
    default:
      return state;
  }
};

const reduceBatches = (state = initialState, action) => {
  const batches = get(action, 'batches', emptyArray);

  switch (action.type) {
    case Actions.BULK_PURCHASE_LABEL_SUCCESS:
      return {
        ...state,
        ...batches.reduce(
          (newState, batchId) => ({
            ...newState,
            [batchId]: getBatchGroupKeyFromBatches(action),
          }),
          {},
        ),
      };
    default:
      return state;
  }
};

export const reduce = (state = initialState, action) => ({
  batchGroups: reduceBatchGroup(state.batchGroups, action),
  batches: reduceBatches(state.batches, action),
});

export { namespace } from './bulk.label.reducer.metadata';
